import styled from 'styled-components';

import { modalScrollbarStyles } from '../../theme';

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: ${modalScrollbarStyles.width};
  }

  &::-webkit-scrollbar-track {
    background: ${modalScrollbarStyles.track};
    border-radius: ${modalScrollbarStyles.borderRadius};
  }

  &::-webkit-scrollbar-thumb {
    background: ${modalScrollbarStyles.thumb};
    border-radius: ${modalScrollbarStyles.borderRadius};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${modalScrollbarStyles.thumbHover};
  }
`;

export default ScrollableContent; 